import {useNavigate} from 'react-router-dom';
import {useState} from 'react';

import {AiOutlineEdit} from 'react-icons/ai';
import {
    FlexiButton,
    FlexiCancelButton
} from "@flexinet/ui-components";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";

export const useEditPageTools = () => {

    const navigate = useNavigate();

    const {allowedActions} = useVerifiedPermissions()

    const [drawerOpened, setDrawerOpened] = useState(false);

    const tools = [];

    if (allowedActions.includes(rbacActions.UpdateCustomer)) {
        tools.push(<FlexiButton leftSection={<AiOutlineEdit/>} variant={'filled'} key={'edit'}
                                onClick={() => setDrawerOpened(true)}>Edit</FlexiButton>);
    }

    tools.push(<FlexiCancelButton key={'close'}
                                  onClick={() => navigate(`/customers`)}/>);


    return {
        drawerOpened,
        setDrawerOpened,
        tools,
    };

};
